import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { makeSelectNiveauFilterContent } from '../selectors';
import { setNiveauFilterDataArray, setNiveauFilterId } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import initialStateConstants from '../initialStateConstants';

/**
 * Applies the ?niveau= query parameter once the filter items are loaded.
 *
 * Unlike the degree filter there is no Drupal-side pre-set for niveau, so the
 * URL is the only source here.
 */
export const NiveauPreFilter = ({ niveauItems, onSetNiveauFilterId, onSetNiveauFilterDataArray }) => {
  const appHistory = useHistory();
  const { search } = useLocation();
  const [queryParams, setQueryParams] = useState(queryString.parse(search)?.niveau ?? '');

  useEffect(() => {
    if (queryParams.length > 0) {
      preFilter(queryParams);
    }
  }, [niveauItems]);

  useEffect(() => {
    let newQueryString = queryString.parse(search)?.niveau ?? '';
    if (newQueryString === queryParams) {
      return null;
    }
    if (appHistory.action === 'POP') {
      preFilter(newQueryString);
    }
    setQueryParams(newQueryString);
  }, [search]);

  const preFilter = (newQueryString) => {
    if (niveauItems.length === 0) {
      return null;
    }
    const filterItems = newQueryString.length > 0 ? newQueryString.split('_') : [];
    if (filterItems.length === 0) {
      resetFilter();
      return null;
    }
    // Unknown keys are dropped — an old link must not filter on a value the
    // field no longer allows.
    const known = filterItems.filter((currentItem) =>
      niveauItems.some((item) => Object.keys(item)[0] === currentItem),
    );
    if (known.length === 0) {
      resetFilter();
      return null;
    }
    onSetNiveauFilterId(known);
    onSetNiveauFilterDataArray(
      known.map((currentItem) => {
        const result = niveauItems.find((item) => Object.keys(item)[0] === currentItem);
        return result[Object.keys(result)].name;
      }),
    );
  };

  const resetFilter = () => {
    onSetNiveauFilterId(initialStateConstants.niveauFilterId);
    onSetNiveauFilterDataArray(initialStateConstants.niveauFilterDataArray);
  };

  return <></>;
};

NiveauPreFilter.propTypes = {
  niveauItems: PropTypes.array,
  onSetNiveauFilterId: PropTypes.func,
  onSetNiveauFilterDataArray: PropTypes.func,
};

NiveauPreFilter.defaultProps = {
  niveauItems: [],
  onSetNiveauFilterId: () => {},
  onSetNiveauFilterDataArray: () => {},
};

const mapStateToProps = createStructuredSelector({
  niveauItems: makeSelectNiveauFilterContent(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetNiveauFilterId: (value) => dispatch(setNiveauFilterId(value)),
    onSetNiveauFilterDataArray: (value) => dispatch(setNiveauFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(NiveauPreFilter);
